import algoliasearch from 'algoliasearch';

let _client = null;

export const client = () => {
  if (_client === null) {
    _client = algoliasearch(ALGOLIA_APPLICATION_ID, ALGOLIA_SEARCH_ONLY_API_KEY); // eslint-disable-line no-undef
  }

  return _client;
};



// WEBPACK FOOTER //
// ./app/javascript/utils/algolia/index.js